import { render, staticRenderFns } from "./novidades.vue?vue&type=template&id=1d0e5b60&scoped=true"
import script from "./novidades.vue?vue&type=script&lang=js"
export * from "./novidades.vue?vue&type=script&lang=js"
import style0 from "./novidades.vue?vue&type=style&index=0&id=1d0e5b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0e5b60",
  null
  
)

export default component.exports